// Team.js

import React from 'react';

import "../../styles/team/Developers.css"

import TitleField from '../text/TitleField';
import TextField from '../text/TextField';


import jad from '../../images/headshots/jadkhalil.png';
import jean from '../../images/headshots/jean-nicolas.png';

import Reveal from '../motion/Reveal';
import { StaggerGroup, StaggerItem } from '../motion/Stagger';

const Developers = () => {


    const DeveloperData = [
        {
            name: 'Jean-Nicolas Rouette',
            title: 'Co-Founder and Full Stack Software Developer',
            info: 
                `Jean focuses on turning complicated workflows into software that feels simple to use. 
                He enjoys sitting down with the people who will actually use the product, understanding how they work, 
                and making sure every screen and interaction makes sense.`,
            headshot: jean,
            skills: ['React-Native', 'Typescript', 'System Design', 'UX', 'Full Stack App Development'],
        },
        {
            name: 'Jad Khalil',
            title: 'Co-Founder and Full Stack Software Developer',
            info: 
                `Jad spends most of his time behind the scenes, building the systems that keep everything running. 
                He enjoys breaking down complicated problems, finding practical solutions, 
                and making sure the software stays reliable as it grows. `,
            headshot: jad,
            skills: [ 'ASP.NET', 'Azure', 'Monereis', 'Auth', 'SQL Database Design'],
        }

    ]



    return (
        <>
            <div>
                <Reveal className="team-developers-titles-container">
                    <TextField
                        className="team-developers-pill-title"
                        text="THE TEAM"
                        fontSize="0.75rem"
                        fontColor="#5a7a1a"
                    />
                    <TitleField
                        className="team-developers-title"
                        title="The People Behind NicheWare"
                    />
                </Reveal>


                <StaggerGroup as="div" className='team-developers-container' scroll staggerChildren={0.2} amount={0.15}>
                    {DeveloperData.map((dev, index) => (

                        <StaggerItem as="div" className='team-developer-info-container' key={dev.name}>

                            <div className='team-developer-headshot-container'>
                                <img className='team-developer-headshot' src={dev.headshot} alt={dev.name}/>
                            </div>

                            <div className='team-developer-text-container'>
                                <TitleField className='team-developer-name' title={dev.name} bold={true}/>
                                <TextField className='team-developer-title' text={dev.title} fontColor='#717C54' fontSize='0.95rem' bold={true}/>
                                <TextField className='team-developer-info' text={dev.info} fontColor='#4A4A4A' fontSize='0.9rem'/>
                            </div>

                            <div className='team-developer-skills-container'>
                                {dev.skills.map((skill, index) => (
                                    <span className="team-developer-skill" key={skill}>
                                        {skill}
                                    </span>
                                ))}
                            </div>

                        </StaggerItem>
                    ))}
                </StaggerGroup>
            </div>


            
            
             
        </>
    )
}


export default Developers;